import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import App from "./App";
import Reducer from "./reducers/reducer";
import "./style.css";

const initData = {
  userDetails: {
    username: null,
    token: null,
    expiresIn: "",
  },
  products: [],
  cart: [],
};

const store = createStore(Reducer, initData);

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
